module.exports = __webpack_public_path__ + "img/icon_transport.0adc16b.svg";